import React from 'react';
import UserName from '../AuthOTP/UserName.SA';
import SecurityCode from '../AuthOTP/SecurityCode.SA';
import { validateNumber } from '../../Inputs/FilterInputFunctions';
import { FormikProps } from 'formik';
import { AuthOTPState } from '../../../store/authOTP/types';
import { AppState } from '../../../store';
import { connect } from 'react-redux';
import { ErrorComponent } from '../../Labels/ErrorComponent';
import { FlowProps } from '../../HOC/HOCProps';

const AuthOTP: React.FC<FlowProps<AuthOTPState>> = (props: FlowProps<AuthOTPState>) => {
    const messageResponse = (
        <ErrorComponent>
            {props.errorMessage?.message.map((item)=>{
                return <span className="normal">{item}</span>
            })}
        </ErrorComponent>
    );
    switch (props.currentStep){
            case 0:
                return (<UserName
                    nextPage={props.nextPage}
                    formikProps={props.formikProps as FormikProps<AuthOTPState>}
                    validateNumber={validateNumber}
                    messageResponse={messageResponse}
            />);
           case 1:
                return (<SecurityCode
                    nextPage={props.nextPage}
                    formikProps={props.formikProps as FormikProps<AuthOTPState>}
                    previousPage={props.previousPage}
                    messageResponse={messageResponse}
            />);
            default:
            return null;
    }
};

const mapStateToProps = (state: AppState) => ({
    errorMessage: state.system.messageResponse
});

export default connect(mapStateToProps)(AuthOTP);